import script from "./StopwatchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StopwatchForm.vue?vue&type=script&setup=true&lang=ts"

import "./StopwatchForm.vue?vue&type=style&index=0&id=67a51d2e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a51d2e"]])

export default __exports__